jQuery(document).ready(function ($) {
  var storecookie = getCookie("storename");
  // if (storecookie)
  //   $(".secondary-nav>li:first-child>a")
  //     .contents()
  //     .filter(function () {
  //       return this.nodeType === 3;
  //     })
  //     .get(1).nodeValue =
  //     storecookie.replace("Urban Nature Store | ", "My Store: ") + " ";
  if (storecookie) {
    
    let storeName = storecookie.replace("Urban Nature Store | ", "");
    storeName = storeName.replace("Urban Nature Store ", "");
    if (storeName.includes(")")) storeName = "North York";
    $(".secondary-nav>li:first-child>a").addClass("has--store");
    
    $(".secondary-nav>li:first-child>a")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Select only text nodes
      })
      .remove();

    $(".secondary-nav>li:first-child>a").append(
      ` My Store:<br><span>${storeName}</span>`
    );
    const w = $(".secondary-nav > li:first-child > a span").outerWidth(true) + 35;
    $(".secondary-nav > li:first-child > a").css("width", w + "px");
    $(".store-search__preferred-name").text(" " + storecookie);
  } 
  else {
      getUserLocation();
  }
 
  $(document).on("click", ".home_del", function () {
    if ($(this).prop("checked") == true) {
      document.cookie = document.cookie = "storename=Home Delivery; path=/";
      var storecookie = getCookie("storename");
      $(".storename").text("");
      if (storecookie) {
        let storeName = storecookie.replace("Urban Nature Store | ", "");
        if (storeName.includes(")")) storeName = "North York";
        $(".secondary-nav>li:first-child>a").addClass("has--store");
        $(".secondary-nav>li:first-child>a")
          .contents()
          .filter(function () {
            return this.nodeType === 3; // Select only text nodes
          })
          .remove();

        $(".secondary-nav>li:first-child>a").append(
          ` My Store:<br><span>${storeName}</span>`
        );
      }

      location.reload();
    } else if ($(this).prop("checked") == false) {
      document.cookie = document.cookie = "storename=; path=/";

      location.reload();
    }
  });
  if (storecookie) {
    const store = stores.find((s) => s.location === storecookie);
    $(".preferred-store").show();
    if (store) {
      const url = `https://maps.google.com?daddr=${store.location},${store.address}`;
      $(".map_section__directions-btn").prop("href", url);
      $(".store-search__preferred-name").prop("href", store.page);
      $(".store-search__preferred-address").text(store.address);
      $(".phone").text(store.phone);
      $(".email").text(store.email);
      $(".email").prop("href", `mailto:${store.email}`);
      $(".map_section__directions-btn").show();
    }
  }
  if (getCookie("storename") == "Home Delivery") {
    setTimeout(function () {
      $(".home_del").prop("checked", true);
      $(".map_section__directions-btn").hide();
    }, 2500);
  } else {
    $(".home_del").prop("checked", false);
  }

  $(".store-search__close-button").click(function () {
    $(".store-selector-container").hide();
  });

  $(".secondary-nav>li:first-child a.secondary-nav__item").click(function (e) {
    e.preventDefault();
    $(this).next().slideToggle(1000);
  });

  document.addEventListener("on:cart:add", (event) => {
    const cart = event.detail.cart;
    const variantId = event.detail.variantId;
    const item = cart.items.find((item) => item.variant_id === variantId);
    if (!item) return;
    addShippingSurcharge(item, "add", cart);
  });

  document.addEventListener("on:line-item:change", (event) => {
    const { cart, variantId, oldQuantity, newQuantity, sku, productUrl } = event.detail;
    let item = cart.items.find((i) => i.variant_id === variantId);

    if (!item && newQuantity === 0 && oldQuantity > 0) {
      item = { sku, quantity: oldQuantity, url: productUrl };
    }
    if (!item) return;

    changeShippingSurcharge(
      item,
      newQuantity > oldQuantity ? "add" : "remove",
      cart
    );
  });

  function addShippingSurcharge(value, type, cart) {
    if (!value || !value.sku) return;
    var item_sku = value.sku;
    var item_title = value.handle;
    jQuery.getJSON(
      "/products/shipping-surcharge-for-" + item_sku + "-" + item_title + ".js",
      function (product) {
        if (product !== "undefined" && product !== "") {
          var variant_id = product.variants[0].id;
          //$('#cover-spin').show(0);
          var params = { quantity: value.quantity, id: variant_id };

          $.ajax({
            type: "POST",
            url: type === "change" ? "/cart/change.js" : "/cart/add.js",
            dataType: "json",
            data: params,
            success: function (data) {
              const surchargeProduct = `<tr class="cart-item grid gap-x-6" id="cart-item-1" data-product-id="${
                data.product_id
              }" data-variant-id="${variant_id}">
                  <td class="cart-item__image">
                    <a href="${
                      data.url
                    }" class="block "><div class="media relative" style="padding-top: 100%;">
                          <svg class="media__placeholder img-fit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>
                        </div></a>
                  </td>
                  <td class="cart-item__details">
                  <a class="cart-item__title m-0 font-bold text-current js-item-name" href="${
                    data.url
                  }">${
                data.title
              }</a><div class="cart-item__info"><strong class="price__current">$${
                data.price / 100
              }
               </strong><div class="cart-item__variants text-sm">
                          <dl class="mt-2 mb-0"></dl></div>

      </div>
                  </td>
                  <td class="cart-item__qty">
                  <div class="flex items-center mt-4">
                
                  <quantity-input class="inline-block">
                    <label class="label visually-hidden" for="quantity-1">Qty</label>
                    <div class="qty-input qty-input--combined inline-flex items-center w-full">
                      <button type="button" class="qty-input__btn btn btn--minus no-js-hidden" name="minus" disabled>
                        <span class="visually-hidden">-</span>
                      </button>
                      <input type="number" class="qty-input__input input" id="quantity-1" name="updates[]" min="0" value="${
                        data.quantity
                      }" data-index="1" data-initial-value="${
                data.quantity
              }" aria-label="Quantity">
                      <button type="button" class="qty-input__btn btn btn--plus no-js-hidden" name="plus" disabled>
                        <span class="visually-hidden">+</span>
                      </button>
                    </div>
                  </quantity-input>                   

              
              </div>
                  </td>
                  <td class="cart-item__total price">
                    <div class="text-theme-light text-sm mb-2 md:hidden">
                      Subtotal
                    </div><strong class="price__current">$${
                      data.line_price / 100
                    }
                  </strong></td>
                </tr>`;

              setTimeout(function () {
                $("#cart-drawer-form table tbody").prepend(surchargeProduct);
                $(".cart-drawer__checkout-buttons button").text(
                  `Checkout - $${
                    (cart.total_price + data.line_price) / 100
                  } CAD`
                );
              }, 500);
            },
          });
        }
      }
    );
  }

  function changeShippingSurcharge(value, type, cart) {
    if (!value || !value.sku || !value.url) return;
    var item_sku = value.sku;
    var item_title = value.url.split("/")[2].split("?")[0];
    jQuery.getJSON(
      "/products/shipping-surcharge-for-" + item_sku + "-" + item_title + ".js",
      function (product) {
        if (product !== "undefined" && product !== "") {
          var variant_id = product.variants[0].id;
          //$('#cover-spin').show(0);
          var params = {
            quantity: type === "add" ? value.quantity : -value.quantity,
            id: variant_id,
          };

          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: params,
            success: function () {},
          });
        }
      }
    );
  }

  document
    .querySelectorAll(".store-locations ul>li")
    .forEach(function (el, index) {
      el.addEventListener("click", function () {
        const activeEl = document.querySelector(
          ".store-locations ul>li.active"
        );
        if (activeEl) {
          activeEl.classList.remove("active");
        }
        el.classList.add("active");
        console.log("index", index);
        showInfoWindow(index); // Call your function here
      });
    });

  if ($(".check-availability")) {
    $(".check-availability").click(function (e) {
      e.preventDefault();
      $(".product-avail-wrapper").addClass("active");
    });
  }
});

let map;
let infoWindows = [],
  markers = [];
var stores = [
  {
    code: "0001",
    lat: "43.6532",
    lng: "79.3832",
    location: "Urban Nature Store | Etobicoke",
    address: "100 The East Mall Unit 8, Toronto, ON M8Z 5X2, Canada",
    phone: "416-491-1417",
    email: "etobicoke@urbannaturestore.ca",
    page: "/pages/etobicoke-toronto-west/",
  },
  {
    code: "0003",
    lat: "44.2312",
    lng: "76.4860",
    location: "Urban Nature Store | Kingston",
    address: "645 Gardiners Rd #102, Kingston, ON K7M 8K2, Canada",
    phone: "613-887-2735",
    email: "kingston@urbannaturestore.ca",
    page: "/pages/kingston/",
  },
  {
    code: "0002",
    lat: "43.5890452",
    lng: "79.6441198",
    location: "Urban Nature Store | Mississauga",
    address: "3055 Dundas St W, Mississauga, ON L5L 3R8, Canada",
    phone: "289-999-5477",
    email: "mississauga@urbannaturestore.ca",
    page: "/pages/mississauga/",
  },
  {
    code: "0002",
    lat: "43.7615",
    lng: "79.4111",
    location: "Urban Nature Store | North York (Toronto East)",
    address: "900 Don Mills Rd. Unit 3A, North York, ON M3C 1V6, Canada",
    phone: "416-646-2439",
    email: "donmills@urbannaturestore.ca",
    page: "/pages/north-york-toronto-east/",
  },
  {
    code: "0002",
    lat: "43.9367",
    lng: "78.8641",
    location: "Urban Nature Store | Oshawa",
    address: "370 Taunton Rd E, Oshawa, ON L1H 7K5, Canada",
    phone: "905-674-6168",
    email: "oshawa@urbannaturestore.ca",
    page: "/pages/oshawa/",
  },
  {
    code: "0002",
    lat: "43.8384",
    lng: "79.0868",
    location: "Urban Nature Store | Pickering",
    address: "609 Kingston Rd, Pickering, ON L1V 3N7, Canada",
    phone: "905-231-0459",
    email: "pickering@urbannaturestore.ca",
    page: "/pages/pickering/",
  },
  {
    code: "0002",
    lat: "43.1594",
    lng: "79.2469",
    location: "Urban Nature Store | St. Catharines",
    address: "280 Geneva St, St. Catharines, ON L2N 2E8, Canada",
    phone: "289-362-2892",
    email: "niagara@urbannaturestore.ca",
    page: "/pages/st-catharines/",
  },
  {
    code: "0002",
    lat: "43.8561",
    lng: "79.3370",
    location: "Urban Nature Store | Markham",
    address: "227 Main St N Unit 5, Markham, ON L3P 1Y5, Canada",
    phone: "905-251-6663",
    email: "markham@urbannaturestore.ca",
    page: "/pages/markham/",
  },
  {
    code: "0002",
    lat: "43.22802",
    lng: "79.93849",
    location: "Urban Nature Store | Ancaster/Hamilton",
    address: "1100 Golf Links Rd, Hamilton, ON L9K 1J8, Canada",
    phone: "289-408-8889",
    email: "hamilton@urbannaturestore.ca",
  },
  {
    code: "0002",
    lat: "43.8049",
    lng: "79.4143",
    location: "Urban Nature Store Thornhill",
    address: "92 Doncaster Ave, Thornhill, ON L3T 1L3, Canada",
    phone: "647-351-9586",
    email: "thornhill@urbannaturestore.ca",
    page: "/pages/thornhill/",
  },
];
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// Initialize the map
function initMap() {
  if (document.getElementById("map")) {
    map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: 43.7, lng: -78.4 }, // Center of USA
      zoom: 8,
    });
    // Add multiple markers
    const locations = [
      {
        lat: 43.227213,
        lng: -79.938245,
        name: "Ancaster/Hamilton",
        info: `
             <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | Ancaster/Hamilton</h2>
              <p><strong>Address:</strong></p>
              <p>1100 Golf Links Rd, Hamilton, ON L9K 1J8</p>
              <p><strong>Email Address:</strong></p>
              <p>hamilton@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">4.9</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★★</span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">7 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/ancaster-hamilton/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 43.61966,
        lng: -79.55021,
        name: "Etobicoke/Toronto West",
        info: `
            <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | Etobicoke</h2>
              <p><strong>Address:</strong></p>
              <p>100 The East Mall Unit 8, Toronto, ON M8Z 5X2</p>
              <p><strong>Email Address:</strong></p>
              <p>etobicoke@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">4.8</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★★</span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">229 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/etobicoke-toronto-west/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 44.24351,
        lng: -76.56873,
        name: "Kingston",
        info: `
              <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | Kingston</h2>
              <p><strong>Address:</strong></p>
              <p>645 Gardiners Rd, Unit 102 Kingston, ON K7M 8K2</p>
              <p><strong>Email Address:</strong></p>
              <p>kingston@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">4.2</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★☆
                </span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">121 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/kingston/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 43.88399,
        lng: -79.26142,
        name: "Markham",
        info: `
             <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | Markham</h2>
              <p><strong>Address:</strong></p>
              <p>227 Main St N Unit 5 Markham, ON L3P 1Y6</p>
              <p><strong>Email Address:</strong></p>
              <p>markham@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">5.0</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★☆
                </span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">28 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/markham/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 43.52152,
        lng: -79.68458,
        name: "Mississauga",
        info: `
             <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | Mississauga</h2>
              <p><strong>Address:</strong></p>
              <p>3055 Dundas Street West (in the Starsky/Mandarin plaza) Mississauga, ON L5L 3R8</p>
              <p><strong>Email Address:</strong></p>
              <p>mississauga@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">4.7</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★★
                </span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">111 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/mississauga/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 43.7272315,
        lng: -79.3417841,
        name: "North York/Toronto East (Don Mills)",
        info: `
             <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | North York (Toronto East, Don Mills)</h2>
              <p><strong>Address:</strong></p>
              <p>900 Don Mills Rd. Unit 3A North York, ON M3C 1V6</p>
              <p><strong>Email Address:</strong></p>
              <p>donmills@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">4.7</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★★
                </span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">174 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/north-york-toronto-east/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 43.9369,
        lng: -78.8642,
        name: "Oshawa",
        info: `
             <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | Oshawa</h2>
              <p><strong>Address:</strong></p>
              <p>370 Taunton Road East Oshawa, ON L1H 7K5</p>
              <p><strong>Email Address:</strong></p>
              <p>oshawa@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">4.7</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★★
                </span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">190 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/oshawa/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 43.81601,
        lng: -79.11879,
        name: "Pickering",
        info: `
            <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | Pickering</h2>
              <p><strong>Address:</strong></p>
              <p>609 Kingston Rd, Pickering, ON L1V 3N7, Canada</p>
              <p><strong>Email Address:</strong></p>
              <p>pickering@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">4.1</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★★
                </span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">150 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/pickering/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 43.17687,
        lng: -79.24053,
        name: "St. Catharines",
        info: `
             <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store | St. Catharines</h2>
              <p><strong>Address:</strong></p>
              <p>280 Geneva St. Catharines ON L2N 2E8</p>
              <p><strong>Email Address:</strong></p>
              <p>niagara@urbannaturestore.ca</p>
              <div class="rating__count inline-block align-middle" style="color:#222; font-size: 14px">4.8</div>
              <div class="rating inline-block align-middle" role="img">
                <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5;font-size: 20px" >★★★★★</span>
              </div>
              <div class="rating__count inline-block align-middle" style="color:#1a73e8; font-size: 14px">71 reviews</div>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/st-catharines/">MORE INFO</a>
              </div>
             </div>
            `,
      },
      {
        lat: 43.80485,
        lng: -79.4143,
        name: "Thornhill",
        info: `
             <div class="custom-info-window">
              <h2 style="font-size: 18px; margin-bottom: 1em;">Urban Nature Store Thornhill</h2>
              <p><strong>Address:</strong></p>
              <p>92 Doncaster Ave, Thornhill, ON L3T 1L3</p>
              <p><strong>Email Address:</strong></p>
              <p>thornhill@urbannaturestore.ca</p>
              <div class="section__block section__block--button">
               <a style="background:#8EBF70; color: #10594A;  font-weight: 600; margin-top:10px; margin-left:5px;" class="btn btn--secondary btn--sm" href="/pages/thornhill/">MORE INFO</a>
              </div>
             </div>
            `,
      },
    ];

    locations.forEach((loc) => {
      addMarker({ lat: loc.lat, lng: loc.lng }, loc.name, loc.info);
    });
  }

  new google.maps.event.addDomListener(window, "load", initAutocomplete);
}
function addMarker(location, name, infoContent) {
  const marker = new google.maps.Marker({
    position: location,
    map: map,
    title: name,
  });
  const infoWindow = new google.maps.InfoWindow({
    content: infoContent,
  });
  markers.push(marker);
  infoWindows.push(infoWindow);

  marker.addListener("click", () => {
    infoWindows.forEach((win) => win.close()); // Close all other info windows
    infoWindow.open(map, marker);
  });
}

function showInfoWindow(index) {
  infoWindows.forEach((win) => win.close()); // Close all open info windows
  map.setCenter(markers[index].getPosition()); // Center the map on the selected marker
  map.setZoom(14); // Optional: Zoom in closer to the marker
  infoWindows[index].open(map, markers[index]); // Open the info window for the selected marker
}

function initAutocomplete() {
  // Get the input element
  const input = document.getElementById("address");
  const inputMobile = document.getElementById("address-mobile");

  // Create the autocomplete object
  const autocomplete = new google.maps.places.Autocomplete(input);
  const autocompleteMobile = new google.maps.places.Autocomplete(inputMobile);

  // Optionally restrict to certain countries or types
  autocomplete.setComponentRestrictions({ country: ["ca"] });
  autocompleteMobile.setComponentRestrictions({ country: ["ca"] });

  autocomplete.addListener("place_changed", function () {
    const place = autocomplete.getPlace();
    if (place.geometry) {
      let userLat = place.geometry.location.lat();
      let userLng = place.geometry.location.lng();
      if (userLat < 0) {
        
        userLat = userLat * -1;
      }
      
      if (userLng < 0) {
      
        userLng = userLng * -1;
      }
      findNearestStores(userLat, userLng);
    }
  });

  autocompleteMobile.addListener("place_changed", function () {
    const place = autocompleteMobile.getPlace();
    if (place.geometry) {
      let userLat = place.geometry.location.lat();
      let userLng = place.geometry.location.lng();
      if (userLat < 0) {
        
        userLat = userLat * -1;
      }
      
      if (userLng < 0) {
      
        userLng = userLng * -1;
      }
      findNearestStores(userLat, userLng);
    }
  });
}

function findNearestStores(lat, lng) {
  const radius = 1; // Radius in km
  const nearestStores = [];
  stores.forEach((store) => {
    const distance = calculateDistance(
      lat,
      lng,
      parseFloat(store.lat),
      parseFloat(store.lng)
    );
    nearestStores.push({ ...store, dist: distance });
  });
  Array.prototype.sortOn = function (key) {
    this.sort(function (a, b) {
      if (a[key] < b[key]) {
        return -1;
      } else if (a[key] > b[key]) {
        return 1;
      }
      return 0;
    });
  };
  console.log("nearestStores",nearestStores)
  nearestStores.sortOn("dist");
  displayNearestStores(nearestStores);
}

function calculateDistance(lat1, lng1, lat2, lng2) {
  const R = 6371; // Radius of Earth in km
  const dLat = degreesToRadians(lat2 - lat1);
  const dLng = degreesToRadians(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degreesToRadians(lat1)) *
      Math.cos(degreesToRadians(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
	if (d>1) return Math.round(d);
	else if (d<=1) return Math.round(d*1000);
	return d;
}

function degreesToRadians(degrees) {
  return degrees * (Math.PI / 180);
}

function displayNearestStores(stores) {
  const storesList = document.querySelectorAll("#acl-dropdown__menu");
  storesList.forEach((li) => {
    li.innerHTML = "";
  });

  stores.forEach((store) => {
    const storeElement = document.createElement("div");
    storeElement.innerHTML =
      '<section class="acl-m--small"><h6 _ngcontent-hjt-c153="" class="acl-store-info__title">' +
      store.location +
      '</h6><a _ngcontent-hjt-c153="" tabindex="0" role="button" href="javascript:void(0)" id="' +
      store.location +
      '" class="acl-store-info__link ng-star-inserted change_storesel">Select</a><address _ngcontent-hjt-c153="" class="acl-store-info__address acl-hidden--if-empty">' +
      store.address +
      "</address></section>";
    storesList[0].appendChild(storeElement);
    const clonedElement = storeElement.cloneNode(true);
    storesList[1].appendChild(clonedElement);
  });

  jQuery(".acl-store-info__link").click(function (e) {
    e.preventDefault();
    const store = $(this).prop("id");
    console.log("Hello", $(this).prop("id"));
    document.cookie = document.cookie = "storename=" + store + " ; path=/";

    let storecookie = getCookie("storename");
    $(".storename").text("");
    if (storecookie) {
      let storeName = storecookie.replace("Urban Nature Store | ", "");
      if (storeName.includes(")")) storeName = "North York";
      $(".secondary-nav>li:first-child>a").addClass("has--store");
      $(".secondary-nav>li:first-child>a")
        .contents()
        .filter(function () {
          return this.nodeType === 3; // Select only text nodes
        })
        .remove();

      $(".secondary-nav>li:first-child>a").append(
        ` My Store:<br><span>${storeName}</span>`
      );
      const w = $(".secondary-nav > li:first-child > a span").outerWidth(true) + 35;
      $(".secondary-nav > li:first-child > a").css("width", w + "px");
    }
    $(".store-selector-container").hide();
    location.reload();
  });
}

function getUserLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        let userLat = position.coords.latitude;
        let userLon = position.coords.longitude;

        // Find the nearest store
        let nearestStore = null;
        let minDistance = Infinity;

        if (userLat < 0) {
        
            userLat = userLat * -1;
        }
        
        if (userLon < 0) {
        
            userLon = userLon * -1;
        }

        stores.forEach((store) => {
          const distance = calculateDistance(
            userLat,
            userLon,
            store.lat,
            store.lng
          );
          console.log("distance", distance);
          if (distance < minDistance) {
            minDistance = distance;
            nearestStore = store;
          }
        });

        // Display the nearest store
        if (nearestStore) {
          console.log(
            `The nearest store is ${
              nearestStore.location
            }, which is ${minDistance.toFixed(2)} km away.`
          );
          document.cookie = document.cookie =
            "storename=" + nearestStore.location + " ; path=/";

          let storecookie = getCookie("storename");
          $(".storename").text("");
          if (storecookie) {
            let storeName = storecookie.replace("Urban Nature Store | ", "");
            if (storeName.includes(")")) storeName = "North York";
            $(".secondary-nav>li:first-child>a").addClass("has--store");
            $(".secondary-nav>li:first-child>a")
              .contents()
              .filter(function () {
                return this.nodeType === 3; // Select only text nodes
              })
              .remove();

            $(".secondary-nav>li:first-child>a").append(
              ` My Store:<br><span>${storeName}</span>`
            );
            const w = $(".secondary-nav > li:first-child > a span").outerWidth(true) + 35;
            $(".secondary-nav > li:first-child > a").css("width", w + "px");
            window.location.reload()
          }
        } else {
          console.log("No stores found.");
        }
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            console.log("Location permission denied. Please allow location access.");
            break;
          case error.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable. Try again later.");
            break;
          case error.TIMEOUT:
            console.log("Request timed out. Please try again.");
            break;
          default:
            console.log("An unknown error occurred. Please try again.");
        }
      }
    );
  } else {
    console.error("Geolocation is not supported by this browser.");
  }


  
}


